import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom' 
import { getOnlineRegistration } from '../Service/Api';
import LazyLoad from 'react-lazyload';
const OnlineRegistration = () => {
  const [data, setData] = useState(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(()=>{
    const getData = async () => {
      try {
        const response = await getOnlineRegistration();
        if (response.status === 200) {
          setData(response.data);
          setShouldRender(true);
        }
      } catch (error) {
        console.log(error)
      }
    }

    getData()
  },[]) 
  if (!shouldRender) {
    return null;
  }

  return (
    <>
     
    <div className="OnlineR">
        <span className="bounce1" style={{display:data ? 'block' : 'none'}}>
        <Link to="https://entab.online/SFSASR" target="_blank" className="parantlogo">
        <LazyLoad>Online Registration</LazyLoad>
        </Link>
       {data?.attachments &&( <Link to={`https://webapi.entab.info/api/image/${data.attachments}`} target="_blank" className="parantlogo-attachment"><i className="bi bi-paperclip"></i>  </Link>)}
        
        </span>
    </div> 
      
    </>
  )
}

export default OnlineRegistration
